import events from '../events/events';

const Tools = {};

/**
 * Tools plugin
 *
 * @param Vue
 * @param options
 */
Tools.install = function(Vue, options)
{
    let methods =
    {
        open(event, payload)
        {
            events.$emit('toolbox.open', 'tools', event, payload);
        },
        
        close()
        {
            events.$emit('toolbox.close');
        },

        setTab(tab)
        {
            events.$emit('toolbox.tab', tab);
        },

        replacePayload(payload)
        {
            events.$emit('toolbox.payload', payload);
        },
    };

    // register global methods
    Vue.tools = methods;

    // register instance methods
    Vue.prototype.$tools = methods;
};

export default Tools;



// WEBPACK FOOTER //
// ./src/js/plugins/tools.js